import { render, staticRenderFns } from "./MediaModal.vue?vue&type=template&id=5023c0f8&scoped=true&"
import script from "./MediaModal.vue?vue&type=script&lang=js&"
export * from "./MediaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5023c0f8",
  null
  
)

export default component.exports